
export const Pricing = ()=>{
    return (
        <div>Pricing</div>
    )
}